module.exports = __webpack_public_path__ + "img/Ute_Back_Side_Right.2153f189.svg";